import React from 'react';

import { LogInForm } from '../components/templates';

const LogInPage = () => {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <LogInForm />
    </div>
  );
};

export default LogInPage;
